/**
 * @lodex-pro/web-portal/routes/Settings — account details.
 *
 * Phase 15 / Task 15.4 (DEC-153) — read-only placeholder. Editing password /
 * profile deferred (session timeout + password reset are separate followups
 * per DEC-152/DEC-153). OPP PR 13a removed the tier row with operator_tier (§58: the plan's
 * template is never shown to the customer).
 */

import React from 'react';
import { usePortalMe } from '../hooks/useOperatorPortal';
import { portalOrgName } from '../nav/org-name';

export function Settings(): React.JSX.Element {
  const { data, isLoading, isError } = usePortalMe();

  return (
    <main style={{ padding: '24px', maxWidth: '640px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '16px' }}>Settings</h1>

      {isLoading && <p role="status">Loading…</p>}
      {isError && <p role="alert">Could not load settings.</p>}

      {data !== undefined && (
        <section aria-label="Account details">
          <dl style={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: '10px 12px' }}>
            <dt style={{ color: 'var(--color-text-tertiary)' }}>Organisation</dt>
            <dd style={{ margin: 0 }}>{portalOrgName(data)}</dd>
            <dt style={{ color: 'var(--color-text-tertiary)' }}>Name</dt>
            <dd style={{ margin: 0 }}>{data.fullName}</dd>
            <dt style={{ color: 'var(--color-text-tertiary)' }}>Email</dt>
            <dd style={{ margin: 0 }}>{data.email}</dd>
            <dt style={{ color: 'var(--color-text-tertiary)' }}>Role</dt>
            <dd style={{ margin: 0 }}>{data.roleCode}</dd>
          </dl>
          <p style={{ marginTop: '20px', color: 'var(--color-text-tertiary)', fontSize: '13px' }}>
            Contact Paelode to change your company&apos;s plan or your role.
          </p>
        </section>
      )}
    </main>
  );
}
